module.exports = __webpack_public_path__ + "7a6e89bcd2dc6a57f95766397919de44.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-50.png
// module id = 130
// module chunks = 0